module.exports = __webpack_public_path__ + "static/Sprouts_pin_hover-08a512211e9074916ee2b8d7bb55e262.png";